// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7337":"ad2866b8","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"3969":"3547e9ae9841b446","7337":"f1ede546df3bd613","8445":"f6efc8d1e0028bf6","8848":"65106ef0c2c6c697"}[chunkId] + ".js";
};